const SCHEMA_FIELD_OPERATIONS = {
  CREATE: 'CREATE',
  ADD: 'ADD',
  UPDATE: 'UPDATE',
  DELETE: 'DELETE',
};

export default SCHEMA_FIELD_OPERATIONS;
